import { render } from "./Nav.vue?vue&type=template&id=edf9247a&ts=true"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"

import "./Nav.vue?vue&type=style&index=0&id=edf9247a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__